import { useEffect, useState } from "react";
import { ModuleInitialiseStep, NeedSetupModuleFragment } from "gql/graphql";

export function useGlobalWizard({
  modules,
}: {
  modules: NeedSetupModuleFragment[];
}) {
  const [step, setStep] = useState<ModuleInitialiseStep | undefined>(undefined);

  useEffect(() => {
    const uninitializedSteps = modules
      .filter((module) => !module.allStepsInitialized)
      .flatMap((module) => module.steps)
      .filter((step) => !step.initialized);

    const firstUninitializedStep = uninitializedSteps.at(0);

    firstUninitializedStep
      ? setStep(firstUninitializedStep.step)
      : setStep(undefined);
  }, [modules]);

  return {
    step,
  };
}
